export default __webpack_public_path__ + "static/media/more.51f9d7a6.svg";